import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as Service from '../services';
import { addAfterLoginNotification } from '../../../components/Toast/utils/notifications';



interface AsyncState {
  isLoading: {
    productDetails: boolean;
    productEdit: boolean;
  };
  isSuccess: boolean;
  isError: boolean;
}

interface TableState extends AsyncState {
  productDetails: any;
  statusData: any;
  editProductRes: any;
  isLogout: any;
  fullResponse: Array<any>;
  categoryData: Array<any>;
  brandsData: Array<any>;
  tagsData: Array<any>;
  rootReducer?: any;
  auth?: any;
  errorMsg?: any;

}

const initialState: TableState = {
  isLoading: {
    productDetails: true,
    productEdit: false,
  },
  isSuccess: false,
  isError: false,
  productDetails: null,
  statusData: null,
  editProductRes: null,
  isLogout: false,
  fullResponse: [],
  categoryData: [],
  brandsData: [],
  tagsData: [],
  errorMsg: null,
};



// Fetch single product by ID
export const fetchProductById = createAsyncThunk(
  "products/fetchProductById",
  async (id: any, thunkAPI) => {
    try {
      return await Service.getOneProduct(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);


export const editProduct = createAsyncThunk('editProductData', async (data: any, thunkAPI) => {
  try {
    return await Service.editProduct(data);
  } catch (error) {
    // thunkAPI.dispatch(resetLogout(error));
    return thunkAPI.rejectWithValue(error);
  }
});



export const productDetailsSlice = createSlice({
  name: 'product details',
  initialState,
  reducers: {
    reset: (state) => {
      state.isLoading.productDetails = false;
      state.isSuccess = false;
      state.isError = false;
      state.productDetails = initialState.productDetails;
    },
  },
  extraReducers: (builder) => {
    builder
      //Obtaining data
      .addCase(fetchProductById.pending, (state, action: any) => {
        state.isLoading.productDetails = true;
        state.isError = false;
        state.errorMsg = null;
        state.productDetails = null;
      })
      .addCase(fetchProductById.fulfilled, (state, action: any) => {
        console.log('action.payload', action.payload)
        state.isLoading.productDetails = false;
        state.isSuccess = true;
        state.isError = false;
        state.productDetails = action.payload.data.response;
        state.errorMsg = null;
      })
      .addCase(fetchProductById.rejected, (state) => {
        state.isLoading.productDetails = false;
        state.isError = true;
        state.productDetails = null;

      })

      .addCase(editProduct.pending, (state) => {
        state.isLoading.productEdit = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMsg = null;
        state.editProductRes = null;
      })
      .addCase(editProduct.fulfilled, (state, action: any) => {
        addAfterLoginNotification('Product Updated successfully', "success");
        state.isLoading.productEdit = false;
        state.isSuccess = true;
        state.isError = false;
        state.editProductRes = action.payload;
      })
      .addCase(editProduct.rejected, (state, action: any) => {
        addAfterLoginNotification( action.payload.errorMsg, "error");
        state.isLoading.productEdit = false;
        state.isSuccess = false;
        state.isError = true;
        state.editProductRes = null;
        state.errorMsg = action.payload.errorMsg;
      })


  },
});

export const { reset } = productDetailsSlice.actions;


export default productDetailsSlice.reducer;
